import {
	SET_SHOP_CATEGORIES,
	SET_SHOP_CATEGORY,
	CLEAR_SHOP_CATEGORIES,
	CLEAR_SHOP_CATEGORY,
	ADD_SHOP_CATEGORY,
	UPDATE_SHOP_CATEGORY,
	REMOVE_SHOP_CATEGORY,
} from './actionTypes';

export const shopCategory = (state = {}, action) => {
	switch (action.type) {
		case SET_SHOP_CATEGORY:
			return action.payload;
		case UPDATE_SHOP_CATEGORY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SHOP_CATEGORY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SHOP_CATEGORIES:
			return action.payload;
		case ADD_SHOP_CATEGORY:
			return [...state, action.payload];
		case UPDATE_SHOP_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SHOP_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SHOP_CATEGORIES:
			return [];
		default:
			return state;
	}
};
